import React, { useRef } from "react";
import { Box } from "@mui/material";

// Distancia (px) que hay que arrastrar hacia abajo para cerrar, o velocidad
// (px/ms) de un deslizamiento rápido que también cierra aunque sea corto.
const CLOSE_DISTANCE = 80;
const CLOSE_VELOCITY = 0.5;

// Barrita del borde superior de los paneles que se abren desde abajo
// (Drawer anchor="bottom"). Tocarla no hace nada; deslizarla hacia abajo
// arrastra el panel con el dedo y lo cierra al soltar si se bajó lo
// suficiente (si no, vuelve a su lugar).
const SheetDragHandle = ({ onClose }) => {
  const drag = useRef(null);

  const paperOf = (el) => el.closest(".MuiDrawer-paper");

  const handlePointerDown = (e) => {
    const paper = paperOf(e.currentTarget);
    if (!paper) return;
    e.currentTarget.setPointerCapture(e.pointerId);
    paper.style.transition = "none";
    drag.current = { paper, startY: e.clientY, startTime: e.timeStamp, dy: 0 };
  };

  const handlePointerMove = (e) => {
    if (!drag.current) return;
    const dy = Math.max(0, e.clientY - drag.current.startY);
    drag.current.dy = dy;
    drag.current.paper.style.transform = `translateY(${dy}px)`;
  };

  const handlePointerUp = (e) => {
    if (!drag.current) return;
    const { paper, dy, startTime } = drag.current;
    drag.current = null;
    const velocity = dy / Math.max(1, e.timeStamp - startTime);
    paper.style.transition = "";
    if (dy > CLOSE_DISTANCE || (dy > 20 && velocity > CLOSE_VELOCITY)) {
      // La animación de salida del Drawer arranca desde donde quedó el panel.
      onClose();
    } else {
      paper.style.transition = "transform 200ms ease-out";
      paper.style.transform = "";
    }
  };

  return (
    <Box
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerUp}
      sx={{ display: "flex", justifyContent: "center", py: 1, mb: 0.5, touchAction: "none", cursor: "grab" }}
    >
      <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: "rgba(128,128,128,0.4)" }} />
    </Box>
  );
};

export default SheetDragHandle;
